import React, { useState, useEffect } from 'react';
import axios from '../api/axios';
import { useAlert } from '../context/AlertContext';
import './ChatAlerts.css';

function ChatAlerts() {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const alert = useAlert();

  const alertLabels = {
    follow: { label: 'Follow', icon: '💜', description: 'Wenn jemand dem Kanal folgt' },
    subscription: { label: 'Subscription', icon: '🎉', description: 'Neues Abo' },
    resub: { label: 'Resub', icon: '💎', description: 'Abo-Verlängerung' },
    subgift: { label: 'Sub Gift', icon: '🎁', description: 'Geschenktes Abo' },
    cheer: { label: 'Cheer/Bits', icon: '💰', description: 'Bits-Donation' },
    host: { label: 'Host', icon: '📺', description: 'Kanal wird gehostet' },
    raid: { label: 'Raid', icon: '🚀', description: 'Raid von anderem Kanal' }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const { data } = await axios.get('/api/chat-alerts/settings');
      setSettings(data);
      setLoading(false);
    } catch (error) {
      alert.error('Fehler beim Laden der Einstellungen');
      setLoading(false);
    }
  };

  const updateSetting = async (type, field, value) => {
    const setting = settings.find(s => s.alert_type === type);
    if (!setting) return;

    const updated = { ...setting, [field]: value };
    
    try {
      await axios.put(`/api/chat-alerts/settings/${type}`, {
        enabled: updated.enabled,
        message: updated.message
      });
      
      setSettings(settings.map(s => s.alert_type === type ? updated : s));
      alert.success('Einstellung gespeichert!');
    } catch (error) {
      alert.error('Fehler beim Speichern');
    }
  };

  if (loading) {
    return <div className="chat-alerts-page"><div className="loading">Lade Einstellungen...</div></div>;
  }

  return (
    <div className="chat-alerts-page">
      <div className="page-header">
        <h2>💬 Chat Alerts</h2>
        <p>Konfiguriere welche Alerts im Chat angezeigt werden</p>
      </div>

      <div className="alerts-grid">
        {settings.map(setting => {
          const info = alertLabels[setting.alert_type] || { label: setting.alert_type, icon: '📢', description: '' };
          
          return (
            <div key={setting.alert_type} className="alert-card">
              <div className="alert-header">
                <div className="alert-title">
                  <span className="alert-icon">{info.icon}</span>
                  <div>
                    <h3>{info.label}</h3>
                    <p className="alert-description">{info.description}</p>
                  </div>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={setting.enabled === 1}
                    onChange={(e) => updateSetting(setting.alert_type, 'enabled', e.target.checked ? 1 : 0)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>

              <div className="alert-message">
                <label>Chat-Nachricht</label>
                <textarea
                  value={setting.message}
                  onChange={(e) => {
                    const updated = settings.map(s => 
                      s.alert_type === setting.alert_type 
                        ? { ...s, message: e.target.value }
                        : s
                    );
                    setSettings(updated);
                  }}
                  onBlur={(e) => updateSetting(setting.alert_type, 'message', e.target.value)}
                  rows="3"
                  disabled={setting.enabled === 0}
                />
                <small className="variables-hint">
                  Verfügbare Variablen: {'{username}'}, {'{months}'}, {'{recipient}'}, {'{bits}'}, {'{viewers}'}
                </small>
              </div>
            </div>
          );
        })}
      </div>

      <div className="info-box">
        <h4>ℹ️ Hinweise</h4>
        <ul>
          <li>Alerts werden nur im Chat angezeigt wenn sie aktiviert sind</li>
          <li>Das Alert-Overlay funktioniert unabhängig von diesen Einstellungen</li>
          <li>Follow-Events werden alle 60 Sekunden geprüft</li>
          <li>Verwende Variablen in geschweiften Klammern für dynamische Inhalte</li>
        </ul>
      </div>
    </div>
  );
}

export default ChatAlerts;
